import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import compose from 'lodash/flowRight';
import reject from 'lodash/reject';
import MLink from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import consumeAppContext from '../../consumers/app';
import { removeEventCommentMutation, eventCommentsQuery } from '../../apollo/events';
import ConfirmButton from '../confirm-button';

const useStyles = makeStyles((theme) => ({
  deleteLink: {
    marginLeft: theme.spacing(1)
  },
  button: {
    paddingBottom: 1,
    fontSize: 12,
  }
}));

const DeleteEventCommentLink = (props) => {
  const classes = useStyles();
  const { comment, event, loggedInUser, removeEventComment } = props;

  if (!loggedInUser || (!event.permissions.editable && comment.user.id !== loggedInUser.id)) {
    return null;
  }

  const handleClick = () => {
    removeEventComment({
      variables: {
        id: comment.id
      }
    });
  };

  return (
    <span className={classes.deleteLink}>
      <ConfirmButton
        buttonComponent={MLink}
        component="button"
        onClick={handleClick}
        className={classes.button}
        label="Delete"
        confirmMessage="Are you sure you would like to delete this comment?"
      />
    </span>
  );
};

DeleteEventCommentLink.propTypes = {
  comment: PropTypes.object,
  event: PropTypes.object,
  loggedInUser: PropTypes.object,
  removeEventComment: PropTypes.func
};

export default compose(
  consumeAppContext,
  graphql(removeEventCommentMutation, {
    name: 'removeEventComment',
    options: ({ event }) => ({
      update: (proxy, { data: { removeEventComment: removedComment } }) => {
        // update event query w/ updated membership object
        const eventQueryVariables = { eventId: event.id };
        const data = proxy.readQuery({
          query: eventCommentsQuery,
          variables: eventQueryVariables,
        });
        proxy.writeQuery({
          query: eventCommentsQuery,
          variables: eventQueryVariables,
          data: {
            ...data,
            event: {
              ...data.event,
              comments: reject(data.event.comments, ({ id }) => id === removedComment.id),
              commentCount: data.event.commentCount - 1,
            }
          }
        });
      }
    })
  })
)(DeleteEventCommentLink);
